/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { VbzButton, VbzModal } from "@smiles/voebiz-ui-kit";
import { ModalHeader, ModalBody } from "reactstrap";
import { v4 } from "uuid";
import { useFlags } from "launchdarkly-react-client-sdk";
import { getDate, getFlightDuration, getHours } from "tests/utils";

import ModalRules from "components/ModalRules";
import ModalWithoutReimbursement from "components/ModalWithoutReimbursement";

import { cancelEligibility } from "../../services/cancelEligibility";

import { ILegList, IPassenger, ISegment } from "../../@types/flight-order";
import { LINK_RULES_BAGGAGE, MOBILE_SIZE } from "../../constants/index";
import { LogoGolAirline, Trace, Airplane, LogoKLM, LogoAirFrance } from "../../assets/index";
import { getCabinDisplayNameFromDeparture, isGolPremiumEnabled } from "../../utils/cabinNomenclature";

interface IModalDetail {
  isOpen: boolean;
  listFlight?: ISegment[];
  // eslint-disable-next-line no-unused-vars
  handleClose: (bol: boolean) => void;
  onExit: () => void;
}

const ModalDetail: React.FC<IModalDetail> = ({ isOpen = false, handleClose, onExit, listFlight }) => {
  const { t } = useTranslation("modalDetail");
  const [isLoading, setIsLoading] = useState(false);
  const [segmentList, setSegmentList] = useState<ISegment[]>();
  const [isModalRules, setIsModalRules] = useState(false);
  const [modalNoReimbursementIsOpen, setModalNoReimbursementIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const flags = useFlags();
  const { apiDomain } = flags;
  const golPremiumEnabled = isGolPremiumEnabled(flags);

  const getRecordLocator = () => {
    return segmentList?.find((segment) => segment)?.recordLocator;
  };

  const operationAirline = {
    G3: LogoGolAirline,
    AF: LogoAirFrance,
    KL: LogoKLM,
  } as any;

  const Airlines = {
    G3: "G3",
    AF: "AF",
    KL: "KL",
  } as const;

  window.addEventListener("resize", () => {
    if (window.innerWidth < MOBILE_SIZE) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  });

  useEffect(() => {
    if (window.innerWidth < MOBILE_SIZE) {
      setIsMobile(true);
    }
  }, [isMobile]);

  const cancelPath = `/minha-conta/meus-voos/cancelar?pnrValue=${getRecordLocator()}`;

  const handleCloseModal = () => {
    handleClose(!isOpen);
  };

  const handleCancelFlight = async () => {
    setIsLoading(true);
    const cancelEligibilityServiceResponse = await cancelEligibility(getRecordLocator(), apiDomain);
    if (
      cancelEligibilityServiceResponse.body.flight.allowedCancelPassenger === "true" ||
      cancelEligibilityServiceResponse.body.flight.allowedCancelSegments === "true" ||
      cancelEligibilityServiceResponse.body.flight.allowedCancelFull === "true"
    ) {
      setIsLoading(false);
      handleClose(!isOpen);
      window.location.href = cancelPath;
      return null;
    }
    setIsLoading(false);
    handleClose(!isOpen);
    setModalNoReimbursementIsOpen(true);
    return null;
  };

  useEffect(() => {
    setSegmentList(listFlight);
  }, [isOpen, listFlight, segmentList]);

  const renderFlightTrace = (segment: ISegment) => {
    return segment?.chosenFlight.legList.map((leg: ILegList, index) => (
      <>
        <div className="label-content">
          <div className="divisor-header">
            <div className="label-trip">
              <div className="icon">
                <img
                  className="logo"
                  src={operationAirline[leg.operationAirline.code]}
                  alt={leg.operationAirline.name}
                  title={leg.operationAirline.name}
                />
              </div>
              <div className="info">
                <span className="title">{leg.operationAirline.name} Linhas Aéreas</span>
                <span className="subtitle">Voo {leg.flightNumber}</span>
                <span className="subtitle">
                  {getCabinDisplayNameFromDeparture(
                    leg.cabin || segment.chosenFlight.cabin,
                    leg.departure,
                    golPremiumEnabled,
                  )}
                </span>
              </div>
            </div>

            {/* Other Airline Operation */}
            {segment.chosenFlight.legList.length >= 2 &&
              (segment.chosenFlight.legList[0]?.operationAirline.code !== Airlines.G3 ||
                segment.chosenFlight.legList[1]?.operationAirline.code !== Airlines.G3) &&
              index === 0 && (
                <div className="other-company-label-info">
                  <span className="description">Trecho operado pela {leg.operationAirline.name}</span>
                </div>
              )}
          </div>

          <div className="label-trip">
            <div className="icon">
              <img className="trace" src={Trace} alt={t("alt")} />
            </div>
            <div className="info">
              <div className="trip-origin-destiny">
                <div className="trip-origin-destiny-info">
                  <div className="trip-origin-destiny-origin" data-testid="origin">
                    <span>{leg.departure.airport.code}</span>{" "}
                    <span>
                      {leg.departure.airport.city}, {leg.departure.airport.country}
                    </span>
                  </div>
                </div>
                <span className="flight-card__originDestiny-length">
                  {getHours(leg.departure.date, "h")} {" - "}
                  {getDate(leg.departure.date)}
                </span>
              </div>

              <div className="trip-origin-destiny">
                <div className="trip-origin-destiny-info">
                  <div className="trip-origin-destiny-origin" data-testid="origin">
                    <span>{leg.arrival.airport.code}</span> {leg.arrival.airport.city}, {leg.arrival.airport.country}
                  </div>
                </div>
                <span className="flight-card__originDestiny-length">
                  {getHours(leg.arrival.date, "h")} {" - "}
                  {getDate(leg.arrival.date)}
                </span>
              </div>
            </div>
          </div>

          <div className="label-trip">
            <div className="icon">
              <span className="material-icons orange-color" role="img" aria-label="Hora" title="Hora">
                &#xe8b5;
              </span>
            </div>
            <div className="info">
              <span className="traveler-time-info font-light">
                {t("flightDuration")}
                <span className="traveler-time-info font-bold">
                  &nbsp;
                  {getFlightDuration(leg.departure.date, leg.arrival.date)}
                </span>
              </span>
            </div>
          </div>
        </div>

        {/* Stops between legs flights */}
        {segment.chosenFlight.stops > "0" && index === 0 && segment.chosenFlight.legList.length >= 2 && (
          <div className="label-content">
            <div className="label-trip">
              <div className="icon">
                <img className="logo" src={Airplane} alt={t("alt")} />
              </div>
              <div className="info">
                <span className="title">
                  {t("stopsDuration")}{" "}
                  {getFlightDuration(
                    segment.chosenFlight.legList[0].arrival.date,
                    segment.chosenFlight.legList[1].departure.date,
                  )}
                </span>
                <span className="subtitle">
                  {leg.arrival.airport.code} - {leg.arrival.airport.city}
                </span>
              </div>
            </div>
          </div>
        )}
      </>
    ));
  };

  const renderPassengers = (passengers: IPassenger[]) => {
    return passengers.map((passenger) => (
      <div>
        <span>{`${passenger.firstName} ${passenger.lastName}`}</span>
      </div>
    ));
  };

  const cancelButton = () => (
    <div className="flight-detail-modal__btn">
      <VbzButton
        type="button"
        id="btn_registerCompany"
        text={t("btn_cancel_flight")}
        color="primary"
        onClick={() => {
          handleCancelFlight();
        }}
        isLoading={isLoading}
      />
    </div>
  );

  return (
    <>
      <VbzModal
        id={v4()}
        className="vbz-register"
        desktopSize={!isMobile ? "big" : "small"}
        isOpen={isOpen}
        hasScroll
        type="right"
        toggle={handleCloseModal}
        backdrop
        defaultHeader={false}
        onExit={onExit}
      >
        <ModalHeader className="modal-header-detail">
          <button
            id="btn_close"
            type="button"
            className="vbz-btn-close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              handleCloseModal();
            }}
          >
            <i className="material-icons">&#xe5cd;</i>
          </button>
        </ModalHeader>

        <ModalBody className="modal-body-flight-details">
          <div className="vbz-modal-text">
            {segmentList?.map((segment: ISegment, index) => (
              <>
                <div className="flight-detail-modal content-margin">
                  {/* Left Column */}
                  <div className="column-child">
                    <h4 className="main-title">
                      {segmentList.length > 1 && index > 0 ? t("arrivalTicket") : t("departureTicket")}
                    </h4>

                    {/* Content */}
                    <div className="origin-destiny">
                      <div className="origin-destiny-info">
                        <div className="origin-destiny-origin" data-testid="origin">
                          <span>{segment.chosenFlight.departure.airport.code}</span>{" "}
                          <span>{segment.chosenFlight.departure.airport.city}</span>
                        </div>
                        <div className="flight-card__icon flight-card__icon--small flight-card__icon--rotate flight-card__originDestiny-icon">
                          <span className="material-icons">&#xe195;</span>
                        </div>
                        <div className="origin-destiny-destiny" data-testid="destiny">
                          <span>{segment.chosenFlight.arrival.airport.code}</span>{" "}
                          <span>{segment.chosenFlight.arrival.airport.city}</span>
                        </div>
                      </div>
                      <span className="flight-card__originDestiny-length">
                        {segment.chosenFlight.stops} {t("stop")} - {`${segment.chosenFlight.duration.hours}h`}{" "}
                        {t("flyingTime")}
                        <span className="flight-card__icon origin-destiny-icon material-icons">&#xE637;</span>{" "}
                        {segment.passengerList.length}
                      </span>
                    </div>

                    {/* Content */}
                    <div className="label-traveler">
                      {segment.passengerList.length > 1 ? (
                        <span className="material-icons" role="img" aria-label={t("travelers")} title={t("travelers")}>
                          &#xe7fe;
                        </span>
                      ) : (
                        <span className="material-icons" role="img" aria-label={t("traveler")} title={t("traveler")}>
                          &#xe7fd;
                        </span>
                      )}
                      <span className="traveler-info">
                        {segment.passengerList.length > 1 ? t("travelers") : t("traveler")}
                      </span>
                    </div>

                    {/* Content */}
                    <div className="flight-card__traveler-info">{renderPassengers(segment.passengerList)}</div>

                    {/* Content */}
                    <div className="label-traveler">
                      <span className="material-icons-outlined" role="img" aria-label="Bagagem" title="Bagagem">
                        &#xf19c;
                      </span>
                      <span className="traveler-info">1 {t("titleHandBaggage")}</span>
                    </div>

                    {/* Content */}
                    <div className="label-info">
                      <div>
                        <span>{t("textContentBaggage")}</span>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="label-traveler normal-margin">
                      <span className="material-icons color-light" role="img" aria-label="Viajante" title="Viajante">
                        &#xf235;
                      </span>
                      <span className="traveler-info">{t("checkedBaggage")}</span>
                    </div>

                    {/* Content */}
                    <div className="label-info-detail">
                      <div>
                        <span>
                          {t("checkedBaggageRules.0")}{" "}
                          <a
                            className="btn_link_rules"
                            color="hyperlink"
                            href={LINK_RULES_BAGGAGE}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {t("checkedBaggageRules.1")}
                          </a>{" "}
                          {t("checkedBaggageRules.2")}
                        </span>
                      </div>
                      <div>
                        <span>{t("checkedBaggageText")}</span>
                      </div>
                    </div>

                    {isMobile && (
                      <>
                        {renderFlightTrace(segment)}
                        <div className="label-trip information">
                          <div className="label-information">
                            <span>{t("warningTimeZoneTitle")}</span> {t("warningTimeZoneText")}
                          </div>
                        </div>
                        <div className="label-trip tariff-rules">
                          <div className="label-tariff-rules">
                            <VbzButton
                              type="button"
                              text={t("tariffRules")}
                              color="hyperlink"
                              onClick={() => {
                                setIsModalRules(true);
                              }}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  {!isMobile && (
                    <>
                      {/* Right Column */}
                      <div className="column-child">
                        {/* Render Trace Flight - Leg List Flight */}
                        {renderFlightTrace(segment)}

                        {/* Warning Time Zone message */}
                        <div className="label-trip information">
                          <div className="label-information">
                            <span>{t("warningTimeZoneTitle")}</span> {t("warningTimeZoneText")}
                          </div>
                        </div>

                        {/* Regras Tarifarias */}
                        <div className="label-trip tariff-rules">
                          <div className="label-tariff-rules">
                            <VbzButton
                              type="button"
                              text={t("tariffRules")}
                              color="hyperlink"
                              onClick={() => {
                                setIsModalRules(true);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </>
            ))}

            {cancelButton()}
          </div>
        </ModalBody>
      </VbzModal>

      {/* Modal Rules Flights */}
      <ModalRules backdrop isOpen={isModalRules} segments={listFlight} toggle={() => setIsModalRules(false)} />
      {/* Modal Rules Flights */}
      <ModalWithoutReimbursement
        isOpenModalReimbursement={modalNoReimbursementIsOpen}
        toggle={() => setModalNoReimbursementIsOpen(false)}
        cancelPathUrl={cancelPath}
      />
    </>
  );
};

export default ModalDetail;
